import { defineMessages } from 'react-intl'

export const jobInfoNotesMessages = defineMessages({
  title: {
    id: 'jobInfoNotesMessages.title',
    description: 'Title for Notes block on JobInfo page',
    defaultMessage: 'Notes',
  },
  addNoteButtonLabel: {
    id: 'jobInfoNotesMessages.addNoteButtonLabel',
    description: 'Label for addNote Button in Images block on JobInfo page',
    defaultMessage: 'Add Note',
  },
  noJobNotesMessage: {
    id: 'jobInfoNotesMessages.noJobNotesMessage',
    description: 'No job notes message on JobInfo page',
    defaultMessage: "To add a new note, click the 'Add Note' button above",
  },
  addNoteLabel: {
    id: 'jobInfoNotesMessages.addNoteLabel',
    description: 'Add Note Label on JobInfo page',
    defaultMessage: 'Add Note',
  },
  editNoteLabel: {
    id: 'jobInfoNotesMessages.editNoteLabel',
    description: 'Edit Note Label on JobInfo page',
    defaultMessage: 'Edit Note',
  },
  editNoteInputPlaceholder: {
    id: 'jobInfoNotesMessages.editNoteInputPlaceholder',
    description: 'Edit Note input placeholder on JobInfo page',
    defaultMessage: 'Type here....',
  },
  deleteModalTitle: {
    id: 'jobInfoNotesMessages.deleteModalTitle',
    description: 'Title for confirm delete job note modal on JobInfo page',
    defaultMessage: 'Delete Note',
  },
  deleteModalMessage: {
    id: 'jobInfoNotesMessages.deleteModalText',
    description: 'Message for confirm delete job note modal on JobInfo page',
    defaultMessage: 'Are you sure you want to delete this note?',
  },
})
